import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmopPublicDocCreateComponent } from './emop-public-doc-create/emop-public-doc-create.component';
import { EmopPublicUsercenterSelectorComponent } from './emop-public-usercenter-selector/emop-public-usercenter-selector.component';
import { EmopPublicWorkflowCreateComponent } from './emop-public-workflow-create/emop-public-workflow-create.component';
import { EmopPublicWorkflowApprovalComponent } from './emop-public-workflow-approval/emop-public-workflow-approval.component';
import { EmopModule } from '../components/emop.module';
import { BaseUiModule } from '../modules/base-ui.module';
import { EmopPublicWorkflowApprovalObjectComponent } from './emop-public-workflow-approval/components/emop-public-workflow-approval-object/emop-public-workflow-approval-object.component';
import { EmopPublicWorkflowApprovalFormComponent } from './emop-public-workflow-approval/components/emop-public-workflow-approval-form/emop-public-workflow-approval-form.component';
import { EmopPublicWorkflowApprovalRecordComponent } from './emop-public-workflow-approval/components/emop-public-workflow-approval-record/emop-public-workflow-approval-record.component';
import { EmopPublicWorkflowApprovalDetailComponent } from './emop-public-workflow-approval/components/emop-public-workflow-approval-detail/emop-public-workflow-approval-detail.component';
import { EmopPublicWorkflowCreateNewComponent } from './emop-public-workflow-create/components/emop-public-workflow-create-new/emop-public-workflow-create-new.component';
import { EmopPublicWorkflowCreateAppointeeComponent } from './emop-public-workflow-create/components/emop-public-workflow-create-appointee/emop-public-workflow-create-appointee.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    EmopPublicDocCreateComponent,
    EmopPublicWorkflowCreateComponent,
    EmopPublicWorkflowCreateNewComponent,
    EmopPublicWorkflowCreateAppointeeComponent,

    EmopPublicUsercenterSelectorComponent,

    EmopPublicWorkflowApprovalComponent,
    EmopPublicWorkflowApprovalObjectComponent,
    EmopPublicWorkflowApprovalFormComponent,
    EmopPublicWorkflowApprovalRecordComponent,
    EmopPublicWorkflowApprovalDetailComponent,
  ],
  imports: [
    BaseUiModule,
    CommonModule,
    EmopModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [],
  exports: [
    EmopPublicDocCreateComponent,
    EmopPublicUsercenterSelectorComponent,
    EmopPublicWorkflowCreateComponent,
    EmopPublicWorkflowApprovalComponent
  ]
})
export class EmopPublicModule { }
